<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wfkWUt/media/FC-9781398476738.jpg?1718046539708" alt="This image is the cover for the book Australia: A Miracle of Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Australia: A Miracle of Life
      </h1>
      <p class="bookDescription body article font2">
        <p>Australia: A Miracle of Life beckons you on a breathtaking expedition alongside Julie as she delves deep into the heart of this timeless and majestic terrain. Picture pristine beaches, winding rivers, rugged mountains, and lush forests that beckon with stories untold. Journey through vibrant cities, tranquil gardens, and quaint towns, immersing yourself in the rich tapestry of traditions and culture that define the Australian spirit. More than a travelogue, this is a poetic tribute to a land and its people. Let the magic of Australia captivate your soul!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julie Moss
      </h2>
      
      <p class="authorDescription body article">Julie Moss writing poetry since her childhood. In 2010, she won the editor’s choice award for a worldwide poetry competition. It was published in an anthology of the best entries. In 1999, her poetry made it to the semi-finals for another competition. It was published online. Julie loves using words as art, to describe the places she sees, humanity and her Christian faith. She hopes you enjoy this anthology about Australia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?198ec98e